import { FormValues, personalSchema } from "./form";
import { useFormContext } from "react-hook-form";

export const usePersonalStep = () => {
  const methods = useFormContext<FormValues>();

  const validatePersonalStep = async () => {
    const values = methods.getValues();
    const result = await personalSchema.safeParseAsync(values);

    if (!result.success) {
      const fieldErrors = result.error.flatten().fieldErrors;

      // エラーを React Hook Form に反映
      Object.entries(fieldErrors).forEach(([key, messages]) => {
        if (messages && messages.length > 0) {
          methods.setError(key as keyof FormValues, {
            type: "manual",
            message: messages[0],
          });
        }
      });

      return false;
    }

    return true;
  };

  return {
    validatePersonalStep,
  };
};
